import { logout, selectIsAuthenticated, selectIsStaff } from "@/auth/state/userSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/reduxHooks";
import { queryClient } from "@/api";

export const useAuth = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isStaff = useAppSelector(selectIsStaff);
  const dispatch = useAppDispatch();

  const tryLogout = () => {
    dispatch(logout());
    queryClient.removeQueries();
  };

  return { isAuthenticated, isStaff, tryLogout };
};
